import { render, staticRenderFns } from "./watchVote.vue?vue&type=template&id=c4122b86"
import script from "./watchVote.vue?vue&type=script&lang=js"
export * from "./watchVote.vue?vue&type=script&lang=js"
import style0 from "./watchVote.vue?vue&type=style&index=0&id=c4122b86&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports